/**
 * Defines min/max width for responsive break points in one place
 */
export const screenDimensions = {
  mobileMax: 639,
  desktopMin: 640
};
